export { default } from './UpdatePasswordModal.component';
